export default __webpack_public_path__ + "static/media/sridhar.70977933.jpeg";